export default {
  label: {
    merchantId: '商户号',
    channelName: '通道名称',
    api: 'api名称',
    status: '状态',
    action: '操作',
    attribute3: '运营商名称',
    attribute4: '概率',
    merchantName: '商户名称'
  },
  status: {
    open: '开启',
    close: '关闭'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/channelList.js